import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class AppPaymentTVService {

  constructor(private http: HttpClient) { }

  // postUrlRequest(url, data, reqHeaders): any {
  //   const headers = new HttpHeaders(reqHeaders);
  //   let apiUrl = environment.API_URL_PAYMENT_TV + url;
  //   return this.http.post(url, data, { headers: headers });
  // }

  postUrlRequest(url, data): any {   
    return this.http.post(url, data);
  }

  postHttpRequest(url, data, reqHeaders): any {
    const headers = new HttpHeaders(reqHeaders);
    return this.http.post(url, data, { headers: headers});
  }

  getRequest(url): any {
    let apiUrl = environment.API_URL_PAYMENT_TV + url;
    return this.http.get(apiUrl);
  }

  getRequestWithParams(url, data): any {
    let apiUrl = environment.API_URL_PAYMENT_TV + url;
    return this.http.get(apiUrl, { params: data });
  }

  postRequest(url, data): any {
    let apiUrl = environment.API_URL_PAYMENT_TV + url;
    return this.http.post(apiUrl, data);
  }

  postCustomRequest(url, data, reqHeaders): any {
    const headers = new HttpHeaders(reqHeaders);
    let apiUrl = environment.API_URL_PAYMENT_TV + url;
    return this.http.post(apiUrl, data, { headers: headers, responseType: 'blob' });
  }

  postFormData(url, data) {
    let apiUrl = environment.API_URL_PAYMENT_TV + url;
    return this.http.post(apiUrl, data);
  }

  postWithQuery(url, data) {
    let apiUrl = environment.API_URL_PAYMENT_TV + url;
    return this.http.post(apiUrl, data);
  }

  postWithFile(url, data, files) {
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append(files[i].key, files[i].file);
    }
    for (const property in data) {
      if (data.hasOwnProperty(property)) {
        formData.append(property, data[property]);
      }
    }
    let apiUrl = environment.API_URL_PAYMENT_TV + url;
    return this.http.post(apiUrl, formData);
  }
}
